/* web/style.css .icon-btn */
.btn { display: inline-flex; align-items: center; justify-content: center; line-height: 1; border: 0; background: transparent; color: var(--text); width: 32px; height: 32px; padding: 0; border-radius: 999px; flex: none; }
.btn :global(.icon) { width: 18px; height: 18px; }
.btn:hover { background: var(--fill); }
